/* unplugin-vue-components disabled */import _toConsumableArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue";
import _imports_0 from '@/assets/img/arrow.png';
import _imports_1 from '@/assets/img/arrow_2.png';
var _hoisted_1 = {
  class: "device-info-collapse-list"
};
var _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "collapse-item-right-icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "arrow_1"
}), /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "arrow_2"
})], -1);
var _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "van-collapse-item-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "van-collapse-item-title-icon"
}), /*#__PURE__*/_createElementVNode("div", null, "基本信息")], -1);
var _hoisted_4 = {
  class: "van-collapse"
};
var _hoisted_5 = {
  class: "van-collapse-content"
};
var _hoisted_6 = {
  class: "content-item"
};
var _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "设备名称:", -1);
var _hoisted_8 = {
  class: "content-item-value"
};
var _hoisted_9 = {
  class: "content-item"
};
var _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "设备型号:", -1);
var _hoisted_11 = {
  class: "content-item-value"
};
var _hoisted_12 = {
  class: "content-item"
};
var _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "设备编号:", -1);
var _hoisted_14 = {
  class: "content-item-value"
};
var _hoisted_15 = {
  class: "content-item"
};
var _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "终端设备编号:", -1);
var _hoisted_17 = {
  class: "content-item-value"
};
var _hoisted_18 = {
  class: "content-item"
};
var _hoisted_19 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "设备类型:", -1);
var _hoisted_20 = {
  class: "content-item-value"
};
var _hoisted_21 = {
  class: "content-item"
};
var _hoisted_22 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "设备位置:", -1);
var _hoisted_23 = {
  class: "content-item-value"
};
var _hoisted_24 = {
  class: "content-item"
};
var _hoisted_25 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "设备负责人:", -1);
var _hoisted_26 = {
  class: "content-item-value"
};
var _hoisted_27 = {
  class: "content-item"
};
var _hoisted_28 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "采购日期:", -1);
var _hoisted_29 = {
  class: "content-item-value"
};
var _hoisted_30 = {
  class: "content-item"
};
var _hoisted_31 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "设备描述:", -1);
var _hoisted_32 = {
  class: "content-item-value"
};
var _hoisted_33 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "设备图片:")], -1);
var _hoisted_34 = {
  class: "content-item-value van-image-list"
};
var _hoisted_35 = /*#__PURE__*/_createElementVNode("div", {
  class: "collapse-item-right-icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "arrow_1"
}), /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "arrow_2"
})], -1);
var _hoisted_36 = /*#__PURE__*/_createElementVNode("div", {
  class: "van-collapse-item-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "van-collapse-item-title-icon"
}), /*#__PURE__*/_createElementVNode("div", null, "厂商信息")], -1);
var _hoisted_37 = {
  class: "van-collapse"
};
var _hoisted_38 = {
  class: "van-collapse-content"
};
var _hoisted_39 = {
  class: "content-item"
};
var _hoisted_40 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "厂家名称:", -1);
var _hoisted_41 = {
  class: "content-item-value"
};
var _hoisted_42 = {
  class: "content-item"
};
var _hoisted_43 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "联系人:", -1);
var _hoisted_44 = {
  class: "content-item-value"
};
var _hoisted_45 = {
  class: "content-item"
};
var _hoisted_46 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "电话:", -1);
var _hoisted_47 = {
  class: "content-item-value"
};
var _hoisted_48 = /*#__PURE__*/_createElementVNode("div", {
  class: "collapse-item-right-icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "arrow_1"
}), /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "arrow_2"
})], -1);
var _hoisted_49 = /*#__PURE__*/_createElementVNode("div", {
  class: "van-collapse-item-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "van-collapse-item-title-icon"
}), /*#__PURE__*/_createElementVNode("div", null, "文档信息")], -1);
var _hoisted_50 = {
  class: "van-collapse"
};
var _hoisted_51 = ["onClick"];
var _hoisted_52 = ["src"];
var _hoisted_53 = ["src"];
var _hoisted_54 = ["src"];
var _hoisted_55 = ["src"];
var _hoisted_56 = ["src"];
var _hoisted_57 = ["src"];
var _hoisted_58 = {
  class: "doc-info"
};
var _hoisted_59 = {
  class: "doc-info-title"
};
var _hoisted_60 = {
  class: "doc-info-content"
};
var _hoisted_61 = {
  class: "doc-size"
};
var _hoisted_62 = {
  class: "doc-size"
};
var _hoisted_63 = /*#__PURE__*/_createElementVNode("div", {
  class: "collapse-item-right-icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "arrow_1"
}), /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "arrow_2"
})], -1);
var _hoisted_64 = /*#__PURE__*/_createElementVNode("div", {
  class: "van-collapse-item-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "van-collapse-item-title-icon"
}), /*#__PURE__*/_createElementVNode("div", null, "巡检任务")], -1);
var _hoisted_65 = {
  class: "van-collapse"
};
var _hoisted_66 = ["onClick"];
var _hoisted_67 = {
  class: "doc-info task-info"
};
var _hoisted_68 = {
  class: "doc-info-title task-title"
};
var _hoisted_69 = {
  key: 0,
  class: "tag-ing tag"
};
var _hoisted_70 = /*#__PURE__*/_createElementVNode("span", null, "进行中", -1);
var _hoisted_71 = [_hoisted_70];
var _hoisted_72 = {
  key: 1,
  class: "tag-cancel tag"
};
var _hoisted_73 = /*#__PURE__*/_createElementVNode("span", null, "已取消", -1);
var _hoisted_74 = [_hoisted_73];
var _hoisted_75 = {
  key: 2,
  class: "tag-cancel tag"
};
var _hoisted_76 = /*#__PURE__*/_createElementVNode("span", null, "未开始", -1);
var _hoisted_77 = [_hoisted_76];
var _hoisted_78 = {
  key: 3,
  class: "tag-expect tag"
};
var _hoisted_79 = /*#__PURE__*/_createElementVNode("span", null, "已逾期", -1);
var _hoisted_80 = [_hoisted_79];
var _hoisted_81 = {
  key: 4,
  class: "tag-complete tag"
};
var _hoisted_82 = /*#__PURE__*/_createElementVNode("span", null, "已完成", -1);
var _hoisted_83 = [_hoisted_82];
var _hoisted_84 = {
  class: "task-title-content"
};
var _hoisted_85 = {
  class: "doc-info-content"
};
var _hoisted_86 = {
  class: "doc-size"
};
var _hoisted_87 = {
  class: "doc-size"
};
var _hoisted_88 = /*#__PURE__*/_createElementVNode("div", {
  class: "collapse-item-right-icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "arrow_1"
}), /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "arrow_2"
})], -1);
var _hoisted_89 = /*#__PURE__*/_createElementVNode("div", {
  class: "van-collapse-item-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "van-collapse-item-title-icon"
}), /*#__PURE__*/_createElementVNode("div", null, "保养任务")], -1);
var _hoisted_90 = {
  class: "van-collapse"
};
var _hoisted_91 = ["onClick"];
var _hoisted_92 = {
  class: "doc-info task-info"
};
var _hoisted_93 = {
  class: "doc-info-title task-title"
};
var _hoisted_94 = {
  key: 0,
  class: "tag-ing tag"
};
var _hoisted_95 = /*#__PURE__*/_createElementVNode("span", null, "进行中", -1);
var _hoisted_96 = [_hoisted_95];
var _hoisted_97 = {
  key: 1,
  class: "tag-cancel tag"
};
var _hoisted_98 = /*#__PURE__*/_createElementVNode("span", null, "已取消", -1);
var _hoisted_99 = [_hoisted_98];
var _hoisted_100 = {
  key: 2,
  class: "tag-cancel tag"
};
var _hoisted_101 = /*#__PURE__*/_createElementVNode("span", null, "未开始", -1);
var _hoisted_102 = [_hoisted_101];
var _hoisted_103 = {
  key: 3,
  class: "tag-expect tag"
};
var _hoisted_104 = /*#__PURE__*/_createElementVNode("span", null, "已逾期", -1);
var _hoisted_105 = [_hoisted_104];
var _hoisted_106 = {
  key: 4,
  class: "tag-complete tag"
};
var _hoisted_107 = /*#__PURE__*/_createElementVNode("span", null, "已完成", -1);
var _hoisted_108 = [_hoisted_107];
var _hoisted_109 = {
  class: "task-title-content"
};
var _hoisted_110 = {
  class: "doc-info-content"
};
var _hoisted_111 = {
  class: "doc-size"
};
var _hoisted_112 = {
  class: "doc-size"
};
var _hoisted_113 = {
  key: 0,
  class: "detail-action"
};
import { ImagePreview } from 'vant';
import { getDeviceDetail } from '@/service/deviceInfo/index';
import { showToast } from 'vant';
import './collapseLite.less';
export default /*#__PURE__*/_defineComponent({
  __name: 'DetailCollapselist',
  props: {
    listData: {
      default: function _default() {
        return {};
      }
    },
    patrolSchemeList: {
      default: function _default() {
        return [];
      }
    },
    patrolGuardList: {
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(__props) {
    var Base64 = require('js-base64').Base64;
    var router = useRouter();
    var route = useRoute();
    var _route$query = route.query,
      factoryId = _route$query.factoryId,
      device_num = _route$query.device_num;
    var id = null; // 设备ID
    // eslint-disable-next-line no-undef
    var props = __props;
    var imgUrl = ref([]);
    var docUrl = ref([]);
    var imagePreShow = ref(false);
    var startPosition = ref(0);
    var activeNames = ref('');
    var action = ref(false);
    var imgClick = function imgClick(index) {
      startPosition.value = index;
      imagePreShow.value = true;
    };
    var getDetail = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _data$eaDevice, res, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return getDeviceDetail({
                factoryId: factoryId,
                deviceNum: device_num
              });
            case 3:
              res = _context.sent;
              data = res.data;
              id = data === null || data === void 0 || (_data$eaDevice = data.eaDevice) === null || _data$eaDevice === void 0 ? void 0 : _data$eaDevice.id;
              return _context.abrupt("return", Promise.resolve());
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", Promise.reject());
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 9]]);
      }));
      return function getDetail() {
        return _ref.apply(this, arguments);
      };
    }();
    // const download = (url: string, fileName: string) => {
    //   const aLink = document.createElement('a');
    //   aLink.style.display = 'none';
    //   aLink.href = url;
    //   aLink.download = fileName;
    //   aLink.target = '_parent';
    //   document.body.appendChild(aLink);
    //   aLink.click();
    //   document.body.removeChild(aLink); // 下载完成移除元素
    // };
    var goToAddPatrolGuard = function goToAddPatrolGuard() {
      if (id) {
        router.push({
          path: '/patrolGuard/complete',
          query: {
            id: id
          }
        });
      } else {
        showToast('获取详情失败请重新获取');
      }
    };
    var goToAddPatrolScheme = function goToAddPatrolScheme() {
      if (id) {
        router.push({
          path: '/addPatrolScheme',
          query: {
            id: id,
            isContent: 1
          }
        });
      } else {
        showToast('获取详情失败请重新获取');
      }
    };
    var goToSchemeDetail = function goToSchemeDetail(taskItemId) {
      if (id) {
        router.push({
          path: '/toPatrolScheme/detail',
          query: {
            taskItemId: taskItemId,
            id: id
          }
        });
      } else {
        showToast('获取详情失败请重新获取');
      }
    };
    var goToGuardDetail = function goToGuardDetail(taskItemId) {
      if (id) {
        router.push({
          path: '/toPatrolGuard/detail',
          query: {
            taskItemId: taskItemId,
            id: id
          }
        });
      } else {
        showToast('获取详情失败请重新获取');
      }
    };
    var openFile = function openFile(url) {
      if (getFileImage(url)) {
        // 图片格式放大
        previewImage([url]);
      } else {
        // 文件夹格式打开
        openNextFile(url);
      }
    };
    // 查看文件详情
    var openNextFile = function openNextFile(url) {
      // if (getFileName(url, ['pdf'])) {
      //   window.open(url, '__bank');
      //   return false;
      // }
      // 自己部署的打开地址
      if (getFileName(url, ['pdf', 'pptx', 'ppt', 'xlsx', 'xls', 'txt', 'docx', 'doc'])) {
        window.open("https://kkfileview.zydltec.com/onlinePreview?url=".concat(encodeURIComponent(Base64.encode(url))), '__bank');
        return false;
      }
    };
    // 判断类型
    var getFileName = function getFileName(name) {
      var fileList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['docx', 'doc', 'pptx', 'ppt', 'pdf', 'xlsx', 'xls', 'txt'];
      var flag = 0;
      if (fileList.length > 0) {
        fileList.map(function (item) {
          var reg = new RegExp("".concat(item, "$"), 'g');
          if (reg.test(name)) {
            flag++;
          }
        });
      }
      return flag;
    };
    // 判断是否是图片
    var getFileImage = function getFileImage(name) {
      var reg = /png$|jpeg$|gif$|jpg$/;
      return reg.test(name);
    };
    // 点击图片放大
    var previewImage = function previewImage(images) {
      var list = images.filter(function (item) {
        return item;
      });
      ImagePreview({
        images: list
      });
    };
    watch(function () {
      return props.listData;
    }, function () {
      var _props$listData, _unref2, _props$listData2, _props$listData3, _props$listData4, _docUrl$value, _docUrl$value2;
      ((_props$listData = props.listData) === null || _props$listData === void 0 ? void 0 : _props$listData.pic) && ((_unref2 = unref((_props$listData2 = props.listData) === null || _props$listData2 === void 0 ? void 0 : _props$listData2.pic)) === null || _unref2 === void 0 ? void 0 : _unref2.forEach(function (item) {
        if (item.attachmentType == 1) {
          imgUrl.value.push((item === null || item === void 0 ? void 0 : item.attachmentUrl) || '');
        }
      }));
      var mainBook = ((_props$listData3 = props.listData) === null || _props$listData3 === void 0 ? void 0 : _props$listData3.mainBook) || [];
      var mainRemark = ((_props$listData4 = props.listData) === null || _props$listData4 === void 0 ? void 0 : _props$listData4.mainRemark) || [];
      (_docUrl$value = docUrl.value).push.apply(_docUrl$value, _toConsumableArray(mainBook));
      (_docUrl$value2 = docUrl.value).push.apply(_docUrl$value2, _toConsumableArray(mainRemark));
    }, {
      immediate: true
    });
    watch([function () {
      return props.patrolGuardList;
    }, function () {
      return props.patrolSchemeList;
    }], function () {
      console.log(props.patrolGuardList.length);
      console.log(props.patrolSchemeList.length);
      if (!props.patrolGuardList.length || !props.patrolSchemeList.length) {
        action.value = true;
      }
    }, {
      immediate: true
    });
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getDetail();
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })));
    return function (_ctx, _cache) {
      var _component_van_image_preview = _resolveComponent("van-image-preview");
      var _component_van_image = _resolveComponent("van-image");
      var _component_van_collapse_item = _resolveComponent("van-collapse-item");
      var _component_van_empty = _resolveComponent("van-empty");
      var _component_van_icon = _resolveComponent("van-icon");
      var _component_van_collapse = _resolveComponent("van-collapse");
      var _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_collapse, {
        modelValue: _unref(activeNames),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return _isRef(activeNames) ? activeNames.value = $event : null;
        }),
        accordion: ""
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_collapse_item, {
            name: "1"
          }, {
            "right-icon": _withCtx(function () {
              return [_hoisted_2];
            }),
            title: _withCtx(function () {
              return [_hoisted_3];
            }),
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.listData.eaDevice.deviceName || '--'), 1)]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.listData.eaDevice.deviceModel || '--'), 1)]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.listData.eaDevice.deviceNum || '--'), 1)]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.listData.eaDevice.terminalDeviceNumber || '--'), 1)]), _createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.listData.deviceTypeName || '--'), 1)]), _createElementVNode("div", _hoisted_21, [_hoisted_22, _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.listData.eaDevice.deviceAddr || '--'), 1)]), _createElementVNode("div", _hoisted_24, [_hoisted_25, _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.listData.eaDevice.devicePrincipalName || '--'), 1)]), _createElementVNode("div", _hoisted_27, [_hoisted_28, _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.listData.eaDevice.buyerTime || '--'), 1)]), _createElementVNode("div", _hoisted_30, [_hoisted_31, _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.listData.eaDevice.deviceInfo || '--'), 1)]), _createElementVNode("div", null, [_hoisted_33, _createElementVNode("div", _hoisted_34, [_createVNode(_component_van_image_preview, {
                show: _unref(imagePreShow),
                "onUpdate:show": _cache[0] || (_cache[0] = function ($event) {
                  return _isRef(imagePreShow) ? imagePreShow.value = $event : null;
                }),
                images: _unref(imgUrl),
                "start-position": _unref(startPosition)
              }, null, 8, ["show", "images", "start-position"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(imgUrl), function (item, index) {
                return _openBlock(), _createBlock(_component_van_image, {
                  key: index,
                  fit: "cover",
                  position: "left",
                  src: item,
                  onClick: function onClick() {
                    return imgClick(index);
                  }
                }, null, 8, ["src", "onClick"]);
              }), 128))])])])])];
            }),
            _: 1
          }), _createVNode(_component_van_collapse_item, {
            name: "2"
          }, {
            "right-icon": _withCtx(function () {
              return [_hoisted_35];
            }),
            title: _withCtx(function () {
              return [_hoisted_36];
            }),
            default: _withCtx(function () {
              var _ctx$listData$eaManuf, _ctx$listData$eaManuf2, _ctx$listData$eaManuf3;
              return [_createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_hoisted_40, _createElementVNode("div", _hoisted_41, _toDisplayString(((_ctx$listData$eaManuf = _ctx.listData.eaManufacturersInfo) === null || _ctx$listData$eaManuf === void 0 ? void 0 : _ctx$listData$eaManuf.manufacturerName) || '--'), 1)]), _createElementVNode("div", _hoisted_42, [_hoisted_43, _createElementVNode("div", _hoisted_44, _toDisplayString(((_ctx$listData$eaManuf2 = _ctx.listData.eaManufacturersInfo) === null || _ctx$listData$eaManuf2 === void 0 ? void 0 : _ctx$listData$eaManuf2.linkMan) || '--'), 1)]), _createElementVNode("div", _hoisted_45, [_hoisted_46, _createElementVNode("div", _hoisted_47, _toDisplayString(((_ctx$listData$eaManuf3 = _ctx.listData.eaManufacturersInfo) === null || _ctx$listData$eaManuf3 === void 0 ? void 0 : _ctx$listData$eaManuf3.linkPhoneNum) || '--'), 1)])])])];
            }),
            _: 1
          }), _createVNode(_component_van_collapse_item, {
            name: "3"
          }, {
            "right-icon": _withCtx(function () {
              return [_hoisted_48];
            }),
            title: _withCtx(function () {
              return [_hoisted_49];
            }),
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_50, [_unref(docUrl).length ? (_openBlock(true), _createElementBlock(_Fragment, {
                key: 0
              }, _renderList(_unref(docUrl), function (item, index) {
                return _openBlock(), _createElementBlock("div", {
                  class: "van-collapse-content van-collapse-doc",
                  key: index,
                  onClick: function onClick($event) {
                    return openFile(item.attachmentUrl);
                  }
                }, [getFileName(item.attachmentUrl, ['docx', 'doc']) ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "info-image",
                  src: require('@/assets/img/device/docx-icon.png')
                }, null, 8, _hoisted_52)) : _createCommentVNode("", true), getFileName(item.attachmentUrl, ['pptx', 'ppt']) ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  class: "info-image",
                  src: require('@/assets/img/device/pptx-icon.png')
                }, null, 8, _hoisted_53)) : _createCommentVNode("", true), getFileName(item.attachmentUrl, ['pdf']) ? (_openBlock(), _createElementBlock("img", {
                  key: 2,
                  class: "info-image",
                  src: require('@/assets/img/device/pdf-icon.png')
                }, null, 8, _hoisted_54)) : _createCommentVNode("", true), getFileName(item.attachmentUrl, ['xlsx', 'xls']) ? (_openBlock(), _createElementBlock("img", {
                  key: 3,
                  class: "info-image",
                  src: require('@/assets/img/device/xlsx-icon.png')
                }, null, 8, _hoisted_55)) : _createCommentVNode("", true), getFileName(item.attachmentUrl, ['txt']) ? (_openBlock(), _createElementBlock("img", {
                  key: 4,
                  class: "info-image",
                  src: require('@/assets/img/device/txt-icon.png')
                }, null, 8, _hoisted_56)) : _createCommentVNode("", true), getFileImage(item.attachmentUrl) ? (_openBlock(), _createElementBlock("img", {
                  key: 5,
                  class: "info-image",
                  src: item.attachmentUrl,
                  fit: "cover"
                }, null, 8, _hoisted_57)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_58, [_createElementVNode("div", _hoisted_59, _toDisplayString(item.attachmentName), 1), _createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, _toDisplayString(item.fileSize || '--'), 1), _createElementVNode("span", _hoisted_62, _toDisplayString(item.createTime || '--'), 1)])])], 8, _hoisted_51);
              }), 128)) : _createCommentVNode("", true), !_unref(docUrl).length ? (_openBlock(), _createBlock(_component_van_empty, {
                key: 1,
                description: "暂无信息",
                "image-size": "40"
              })) : _createCommentVNode("", true)])];
            }),
            _: 1
          }), _ctx.patrolSchemeList.length ? (_openBlock(), _createBlock(_component_van_collapse_item, {
            key: 0,
            name: "4"
          }, {
            "right-icon": _withCtx(function () {
              return [_hoisted_63];
            }),
            title: _withCtx(function () {
              return [_hoisted_64];
            }),
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_65, [_ctx.patrolSchemeList.length ? (_openBlock(true), _createElementBlock(_Fragment, {
                key: 0
              }, _renderList(_ctx.patrolSchemeList, function (item, index) {
                return _openBlock(), _createElementBlock("div", {
                  class: "van-collapse-content van-collapse-doc van-collapse-task",
                  key: index,
                  onClick: function onClick() {
                    return goToSchemeDetail(item.taskItemId);
                  }
                }, [_createElementVNode("div", _hoisted_67, [_createElementVNode("div", _hoisted_68, [item.status == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_69, _hoisted_71)) : _createCommentVNode("", true), item.status == -1 ? (_openBlock(), _createElementBlock("div", _hoisted_72, _hoisted_74)) : _createCommentVNode("", true), item.status == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_75, _hoisted_77)) : _createCommentVNode("", true), item.status == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_78, _hoisted_80)) : _createCommentVNode("", true), item.status == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_81, _hoisted_83)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_84, _toDisplayString(item.info || '--'), 1)]), _createElementVNode("div", _hoisted_85, [_createElementVNode("div", _hoisted_86, "任务类型:" + _toDisplayString(item.taskRuleType), 1), _createElementVNode("span", _hoisted_87, "计划巡检时间:" + _toDisplayString(item.taskRuleTimeStr), 1)])]), _createVNode(_component_van_icon, {
                  name: "arrow"
                })], 8, _hoisted_66);
              }), 128)) : _createCommentVNode("", true), !_ctx.patrolSchemeList.length ? (_openBlock(), _createBlock(_component_van_empty, {
                key: 1,
                description: "暂无任务",
                "image-size": "40"
              })) : _createCommentVNode("", true)])];
            }),
            _: 1
          })) : _createCommentVNode("", true), _ctx.patrolGuardList.length ? (_openBlock(), _createBlock(_component_van_collapse_item, {
            key: 1,
            name: "5"
          }, {
            "right-icon": _withCtx(function () {
              return [_hoisted_88];
            }),
            title: _withCtx(function () {
              return [_hoisted_89];
            }),
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_90, [_ctx.patrolGuardList.length ? (_openBlock(true), _createElementBlock(_Fragment, {
                key: 0
              }, _renderList(_ctx.patrolGuardList, function (item, index) {
                return _openBlock(), _createElementBlock("div", {
                  class: "van-collapse-content van-collapse-doc van-collapse-task",
                  key: index,
                  onClick: function onClick() {
                    return goToGuardDetail(item.taskItemId);
                  }
                }, [_createElementVNode("div", _hoisted_92, [_createElementVNode("div", _hoisted_93, [item.status == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_94, _hoisted_96)) : _createCommentVNode("", true), item.status == -1 ? (_openBlock(), _createElementBlock("div", _hoisted_97, _hoisted_99)) : _createCommentVNode("", true), item.status == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_100, _hoisted_102)) : _createCommentVNode("", true), item.status == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_103, _hoisted_105)) : _createCommentVNode("", true), item.status == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_106, _hoisted_108)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_109, _toDisplayString(item.info || '--'), 1)]), _createElementVNode("div", _hoisted_110, [_createElementVNode("div", _hoisted_111, "任务类型:" + _toDisplayString(item.taskRuleType), 1), _createElementVNode("span", _hoisted_112, "计划巡检时间:" + _toDisplayString(item.taskRuleTimeStr), 1)])]), _createVNode(_component_van_icon, {
                  name: "arrow"
                })], 8, _hoisted_91);
              }), 128)) : _createCommentVNode("", true), !_ctx.patrolGuardList.length ? (_openBlock(), _createBlock(_component_van_empty, {
                key: 1,
                description: "暂无任务",
                "image-size": "40"
              })) : _createCommentVNode("", true)])];
            }),
            _: 1
          })) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["modelValue"]), _unref(action) ? (_openBlock(), _createElementBlock("div", _hoisted_113, [_withDirectives(_createVNode(_component_van_button, {
        icon: "plus",
        type: "success",
        class: "btn_1",
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return goToAddPatrolGuard();
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(" 保养内容 ")];
        }),
        _: 1
      }, 512), [[_vShow, !_ctx.patrolGuardList.length]]), _withDirectives(_createVNode(_component_van_button, {
        icon: "plus",
        type: "primary",
        class: "btn_2",
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return goToAddPatrolScheme();
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(" 巡检内容 ")];
        }),
        _: 1
      }, 512), [[_vShow, !_ctx.patrolSchemeList.length]])])) : _createCommentVNode("", true)]);
    };
  }
});